import * as React from 'react';
import * as style from './ContentWrapper.css';

export const ContentWrapper = ({ children }: React.PropsWithChildren) => {
  return (
    <div className={style['wrapper']}>
      <div className={style['inner']}>{children}</div>
    </div>
  );
};
